
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/wixData/components/emptyExternalDbItem/emptyExternalDbItem.scss.css.virtualfile';
        module.exports = {"emptyText":"_emptyText_1n6lv_1"};